import { connect } from 'react-redux';

import { Creators as transientActions } from 'Reducers/transient';
import { Creators as adminActions } from 'Reducers/adminOnboarding';

import RejectSection from './view';

export default connect(
  state => ({
    transient: state.transient,
    userOnboardingProfile: state.adminOnboarding.userOnboardingProfile
  }),
  {
    updateTransientProps: transientActions.updateProps,
    updateOnboardingUserSection: adminActions.updateOnboardingUserSection,
    updateOnboardingUserProfile: adminActions.updateOnboardingUserProfile,
    updateTransientPropWithValidations: transientActions.updatePropWithValidations
  }
)(RejectSection);
